"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyCertificationBind = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var VerifyCertificationBind = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VerifyCertificationBind, _super);
    function VerifyCertificationBind() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '验证实名绑卡接口';
        _this.code = '101002';
        _this.desc = '验证实名绑卡接口';
        _this.requestParams = new bankCard_1.VerifyCertificationBindRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return VerifyCertificationBind;
}(service_1.BaseService));
exports.VerifyCertificationBind = VerifyCertificationBind;
//# sourceMappingURL=verifyCertificationBind.js.map